module.exports = __webpack_public_path__ + "img/za.c0c7f3ff.svg";